import React, {useEffect, useState} from "react";
import {GetOperationType} from "../../../models/_tickets";
import store from "store2";
import { useSiteVisitation } from "../../../providers/SiteVisitationProvider";

const Operation = (props: {
  jobId:any;
}) => {
  const {jobId} = props;
  const [selectedOperation, setSelectedOperation] = useState<string[]>([]);
  const [operationOther, setOperationOther] = useState<string>("");
  const { operationDB, handleLocationOtherOperationChange, handleUpdateLocationOperation } = useSiteVisitation()
  useEffect(() => {
    const jobData = store.get("job_id_data") || {};
    const jobSpecificData = jobData[jobId] || {};

    const savedOps = jobSpecificData.location?.selectedOperations || [];
    const savedOther = jobSpecificData.location?.operationOther || "";

    if (savedOps.length > 0) {
      setSelectedOperation(savedOps);
    }
    if (savedOther) {
      setOperationOther(savedOther);
    }
  }, [jobId]);

  const handleCheckboxChange = (operationId: string) => {
    setSelectedOperation((prev) => {
      const updatedSelection = prev.includes(operationId)
        ? prev.filter((id) => id !== operationId) // Remove if already selected
        : [...prev, operationId]; // Add if not selected
        return updatedSelection;
    });
    handleUpdateLocationOperation(jobId, operationId);
  };

  const handleOtherOperationChange = (value: string) => {
    setOperationOther(value);
    handleLocationOtherOperationChange(jobId, value);
  };

  return (
    <div className="accordion" id="operationAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header" id="operationHeading">
          <button
            className="accordion-button collapsed py-5 fs-4 fw-bold bg-light"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#operationCollapse"
          >
            Operations
          </button>
        </h2>
        <div id="operationCollapse" className="accordion-collapse collapse">
          <div className="accordion-body p-3">
            <div className="row">
              {operationDB.map((operation: GetOperationType, index: number) => (
                 <div key={operation.id} className="col-lg-6 col-md-6 col-12 mb-2">
                  <div className="form-check form-check-custom form-check-solid d-flex align-items-center">
                    <input
                      id={`operation_${index}`}
                      className="form-check-input mb-2 me-1"
                      type="checkbox"
                      checked={selectedOperation.includes(operation.id)}
                      onChange={() => handleCheckboxChange(operation.id)}
                    />
                    <label
                      htmlFor={`operation_${index}`}
                      className="form-check-label fs-5"
                    >
                      {operation.name}
                    </label>
                  </div>
                </div>
              ))}
              {selectedOperation.includes("other") && (
                <div className="col-lg-6 mb-2 p-2">
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Enter other operation"
                  value={operationOther}
                  onChange={(e) => handleOtherOperationChange(e.target.value)}
                />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Operation;
